import * as React from 'react';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { LoadingButton } from '@mui/lab';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {
  Box,
  Chip,
  CircularProgress,
  FormControl,
  Icon,
  IconButton,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { addHospitalInformation, updateHospitalInformation } from '../../api/admin/hospitalInformation';

const initialState = {
  banner: '',
  aboutUs: '',
  doctorsDirectory: '',
  whatsNew: '',
  servicesAndFacilities: '',
  linkToWebsite: '',
  location: '',
};

export default function HospitalInformationDialog({
  dialogOpen,
  setDialogOpen,
  setDialogOpen1,
  selectedItem,
  action,
  setSnackbarMessage,
  setSnackbarOpen,
  setHospitalInformation,
  hospitalInformation
}) {
  const { commonData } = useSelector((state) => state.adminUser.user)
  const account = useSelector((state) => state.account)

  const theme = useTheme();
  const [inputs, setInputs] = useState(initialState);
  const [tempInputs, setTempInputs] = useState();
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);


  const handleSubmit = async (e) => {
    e.preventDefault()
    console.log('chk', inputs, account);
    setIsLoading(true)

    try {
      const { data } = action === 'CREATE' ? await addHospitalInformation(account.hospitalAccount._id, inputs) : await updateHospitalInformation(account.hospitalAccount._id, inputs)
      console.log({ data });
      if (data.success) {

        setHospitalInformation(data.hospitalInformation)
        setIsLoading(false);
        setSnackbarMessage({ msg: data.message, success: true });
        setSnackbarOpen(true);
        setDialogOpen(false);

      } else {
        setIsLoading(false);
        setSnackbarMessage({ msg: data.message, success: false });
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.log({ error });
      setIsLoading(false);
      setSnackbarMessage({ msg: error.message, success: false });
      setSnackbarOpen(true);
    }
  };

  const handleInputChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value })
  };

  const handleSelect = (event) => {
    console.log(event.target.value);
    // setRole(event.target.value);
    setInputs({ ...inputs, roleId: event.target.value })
  };

  const handleClose = () => {
    setDialogOpen(false);
  };
  const handleSkip = () => {
    setDialogOpen(false);
    setDialogOpen1(true);
  };
  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
    setTempInputs({ ...tempInputs, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    console.log('in hook', action, hospitalInformation);
    if (action !== 'CREATE' && hospitalInformation) {
     console.log('in');
      setInputs({
        banner: '',
        aboutUs: hospitalInformation.aboutUs,
        doctorsDirectory: hospitalInformation.doctorsDirectory,
        whatsNew: hospitalInformation.whatsNew,
        servicesAndFacilities: hospitalInformation.servicesAndFacilities,
        linkToWebsite: hospitalInformation.linkToWebsite,
        location:  hospitalInformation.location,
      })
    }
    else {
      setInputs(initialState);
    }
  }, [dialogOpen])

  return (
    <Box>
      <Dialog open={dialogOpen} onClose={handleClose}>
        <DialogTitle>{action === 'CREATE' ? "Add" : "Edit"} Hospital Information</DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent>

            <TextField
              required
              autoFocus
              margin="dense"
              name="aboutUs"
              label="About Us"
              type="text"
              fullWidth
              variant="standard"
              value={inputs.aboutUs}
              onChange={handleInputChange}
            />



            <TextField
              required
              margin="dense"
              name="doctorsDirectory"
              label="Doctors Directory(DoctorName - Field)"
              type="text"
              fullWidth
              variant="standard"
              value={inputs.doctorsDirectory}
              onChange={handleInputChange}
            />
            <TextField
              required
              margin="dense"
              name="whatsNew"
              label="whats New"
              type="text"
              fullWidth
              variant="standard"
              value={inputs.whatsNew}
              onChange={handleInputChange}
            />
            <TextField
              required
              margin="dense"
              name="servicesAndFacilities"
              label="Services And Facilities"
              type="text"
              fullWidth
              variant="standard"
              value={inputs.servicesAndFacilities}
              onChange={handleInputChange}
            />
            <TextField
              required
              margin="dense"
              name="linkToWebsite"
              label="Website"
              type="text"
              fullWidth
              variant="standard"
              value={inputs.linkToWebsite}
              onChange={handleInputChange}
            />
            <TextField
              required
              margin="dense"
              name="location"
              label="Location"
              type="text"
              fullWidth
              variant="standard"
              value={inputs.location}
              onChange={handleInputChange}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <LoadingButton loading={isLoading} type='submit' color='inherit'>{action === 'CREATE' ? "Add" : "Update"}</LoadingButton>
          </DialogActions>
        </form>
      </Dialog>
    </Box>
  )
}
